const fromLeg = (leg) => {
    return leg.flightStops.filter((stop) => stop && !stop.changeOfGauge);
};
const fromSegment = (segment) => {
    return segment.legs.map((leg) => fromLeg(leg)).flat();
};
const getTechnicalStops = { fromLeg, fromSegment };
export default getTechnicalStops;
